import * as ACTION_TYPES from "../actions/actionTypes";
import dotProp from "dot-prop-immutable";

const INITIAL_STATE = {
  users: [],
  isNewUserModalOpen: false,
  isUsersTableEditable: false,
  newUsers: [],
  isUsersLoading: false,
  isUserSaving: false,
  isUserCreating: false,
  isDeleteUserModalOpen: false,
  deleteUserIndex: null
};

export default (state = INITIAL_STATE, action) => {
  const { UPDATE_USER_PROPS, MERGE_USER_PROPS, DELETE_USER_PROPS, CLEAR_STATE } = ACTION_TYPES;
  switch (action.type) {
    case UPDATE_USER_PROPS: {
      let newState = state;
      for (let i = 0; i < action.payload.length; i++) {
        newState = dotProp.set(newState, action.payload[i].prop, action.payload[i].value);
      }
      return newState;
    }
    case MERGE_USER_PROPS: {
      let newState = state;
      for (let i = 0; i < action.payload.length; i++) {
        newState = dotProp.merge(newState, action.payload[i].prop, action.payload[i].value);
      }
      return newState;
    }
    case DELETE_USER_PROPS: {
      let newState = state;
      for (let i = 0; i < action.payload.length; i++) {
        newState = dotProp.delete(newState, action.payload[i].prop);
      }
      return newState;
    }
    case CLEAR_STATE: {
      let newState = state;
      newState = INITIAL_STATE;
      return newState;
    }
    default:
      return state;
  }
};
